import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Modal: ComponentStyleConfig = {
  parts: [
    'ModalStyles',
    'OverlayStyles',
    'ContentStyles',
    'HeaderStyles',
    'CloseButtonStyles',
    'DividerStyles',
    'BodyStyles',
    'FooterStyles',
  ],
  baseStyle: (props: StyleFunctionProps) => {
    return {
      ModalStyles: {
        size: 'md',
      },
      OverlayStyles: {},
      ContentStyles: {},
      HeaderStyles: {
        fontWeight: 500,
        fontSize: 'md',
        wordWrap: 'break-word',
      },
      CloseButtonStyles: {
        _focus: { boxShadow: 'unset' },
      },
      DividerStyles: {
        borderColor: mode('gray.400', 'whiteAlpha.400')(props),
      },
      BodyStyles: { pt: 8, pb: 8, pl: 8, pr: 8 },
      FooterStyles: {},
    };
  },
};

export default Modal;
